import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as baseCls } from '../../style';

const brpM = createBreakpoint('m');

export const mainCls = `${baseCls}__sDetails`;
export const lineCls = `${mainCls}__line`;
export const goToQbCls = `${mainCls}__qb`;

export default {
  [goToQbCls]: {
    position: 'absolute',
    top: 0,
    right: 0,

    padding: 12,
    border: 0,
    [brpM]: {
      transition: createTransition(['color']),
      '&:hover': {
        color: `${colors.secondary.rgba} !important`,
      },
    },
  },
  [lineCls]: {
    lineHeight: '22px',
  },
};
